import $ from 'jquery';
import Flickity from 'flickity';

export default class RecentlyViewed {
  constructor(section) {
    this.$el = $(section.el);
    this.recentlyViewed = section.data.recently_viewed_info;
    this.time = section.data.time;
    this.flickity = null;

    if (this.recentlyViewed && this.time) {
      this.recentlyViewed.timestamp = Math.round((new Date()).getTime() / 1000);
    }

    if (this.time) {
      let recentlyViewed = [];

      if (JSON.parse(localStorage.getItem('recentlyViewed')) !== null) {
        recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'));

        for (let i = recentlyViewed.length - 1; i >= 0; i--) {
          const timeSince = this.timeSince(recentlyViewed[i].timestamp);

          this.$el.find('[data-recently-viewed-container]').append(
            `<div class="product-recently-viewed-card"
              data-recently-viewed-card
            >
              <div class="product-recently-viewed-card-time">
                ${timeSince}
                <div class="product-recently-viewed-card-remove"
                  data-remove-recently-viewed="${recentlyViewed[i].handle}">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M6.08785659,5 L9.77469752,1.31315906 L8.68684094,0.225302476 L5,3.91214341 L1.31315906,0.225302476 L0.225302476,1.31315906 L3.91214341,5 L0.225302476,8.68684094 L1.31315906,9.77469752 L5,6.08785659 L8.68684094,9.77469752 L9.77469752,8.68684094 L6.08785659,5 Z"></path>
                  </svg>
                </div>
              </div>
              <a href="${recentlyViewed[i].link}">
                <div
                  class="product-recently-viewed-card-image-wrapper productitem--image"
                  style="background-image: url(${recentlyViewed[i].image})"
                >
                  <img class="product-recently-viewed-card-image" src="${recentlyViewed[i].image}">
                </div>
              </a>
              <div class="product-recently-viewed-card-price">
                ${recentlyViewed[i].price}
              </div>
              <a
                href="${recentlyViewed[i].link}"
                class="product-recently-viewed-card-title"
              >
                ${recentlyViewed[i].title}
              </a>
            </div>`
          )
        }

        if (this.recentlyViewed) {
          this.removeRecentlyViewed(this.recentlyViewed.handle, recentlyViewed);

          recentlyViewed.push(this.recentlyViewed);
          localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
        }

        this.$carousel = this.$el.find('.product-recently-viewed--content');
        this.slides = '.product-recently-viewed-card';

        if (this.$carousel.find(this.slides).length > 1) {
          this._initSlider();
        }
      } else {
        if (this.recentlyViewed) {
          recentlyViewed.push(this.recentlyViewed);
          localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
        }

        this.$el.find('.product-recently-viewed--section').addClass('hide');
      }
    }

    this.bindEvents();
  }

  bindEvents() {
    this.$el.on('click', '[data-remove-recently-viewed]', (event) => {
      const $target = $(event.currentTarget);
      const handle = $target.data('remove-recently-viewed');
      const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'));

      this.removeRecentlyViewed(handle, recentlyViewed);
      localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));

      $target.parents('[data-recently-viewed-card]').addClass('hide-card');
      $target.parents('[data-recently-viewed-card]').nextAll().addClass('move-card');

      setTimeout(() => {
        let index = $target.parents('[data-recently-viewed-card]').index();
         if (index !== 0) {
          index--;
         }

        $target.parents('[data-recently-viewed-card]').nextAll().removeClass('move-card');
        this.flickity.remove($target.parents('[data-recently-viewed-card]'));
        this.flickity.selectCell(index);
      }, 500);
    });

    this.$el.on('click', '[data-clear-recently-viewed]', (event) => {
      this.clearRecentlyViewed();
    });
  }

  timeSince(timestamp) {
    const now = Math.round((new Date()).getTime() / 1000);
    const secondsPast = now - timestamp;

    if(secondsPast < 60){
      const secondsAgo = parseInt(secondsPast);

      return secondsAgo === 1 ?
        `${secondsAgo} ${this.time.second} ${this.time.ago}` :
        `${secondsAgo} ${this.time.seconds} ${this.time.ago}`;
    }

    if(secondsPast < 3600){
      const minutesAgo = parseInt(secondsPast/60);

      return minutesAgo === 1 ?
        `${minutesAgo} ${this.time.minute} ${this.time.ago}` :
        `${minutesAgo} ${this.time.minutes} ${this.time.ago}`;
    }

    if(secondsPast <= 86400){
      const hoursAgo = parseInt(secondsPast/3600);

      return hoursAgo === 1 ?
        `${hoursAgo} ${this.time.hour} ${this.time.ago}` :
        `${hoursAgo} ${this.time.hours} ${this.time.ago}`;
    }

    if(secondsPast > 86400){
      const date = new Date(timestamp);
      const currentDate = new Date(now);
      const day = date.getDate();
      const month = date.toDateString().match(/ [a-zA-Z]*/)[0].replace(' ', '');
      const year = date.getFullYear() == currentDate.getFullYear() ? '' :  `, ${date.getFullYear()}`;

      return `${month} ${day} ${year}`;
    }
  }

  removeRecentlyViewed(handle, recentlyViewed) {
    for (let i = 0; i < recentlyViewed.length; i++) {
      if (recentlyViewed[i].handle === handle) {
        recentlyViewed.splice(i, 1);

        if (recentlyViewed.length === 0) {
          this.$el.find('.product-recently-viewed--section').addClass('hide');
        }
      }
    }
  }

  clearRecentlyViewed() {
    localStorage.setItem('recentlyViewed', null);
    this.$el.find('[data-recently-viewed-card]').remove();
    this.$el.find('.product-recently-viewed--section').addClass('hide');
  }

  _initSlider() {
    this.flickityOptions = {
      autoPlay: 0,
      accessibility: true,
      cellAlign: 'left',
      cellSelector: this.slides,
      groupCells: true,
      imagesLoaded: true,
      pageDots: false,
      contain: true,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
    };

    this.flickity = new Flickity(this.$carousel[0], this.flickityOptions);

    setTimeout(() => {
      this.flickity.resize();
    }, 100);
  }
}
